module.exports = __webpack_public_path__ + "img/W-18.9e753904.jpg";